export const mobileNavBreakpoint = 1120;